/** What a business does. It says which module fits it; every module is sold apart. */
export type LineOfBusiness = 'RETAIL' | 'RESTAURANT' | 'GYM' | 'PAWNSHOP' | 'PROCESSES' | 'LIVESTOCK' | 'AGRICULTURE' | 'SERVICES'
/** The modules BsPOS sells apart from its base, by the code BsPOS API keeps. */
export type ModuleCode = 'restaurant' | 'gym' | 'pawnshop' | 'processes' | 'livestock' | 'agriculture' | 'accounting' | 'crm' | 'services'
  | 'payroll' | 'website' | 'healthcare' | 'marketing' | 'fleet' | 'parking'

export const lineOfBusinessLabels: Record<LineOfBusiness, string> = {
  RETAIL: 'Comercio en general',
  RESTAURANT: 'Restaurante',
  GYM: 'Gimnasio',
  PAWNSHOP: 'Casa de empeño',
  PROCESSES: 'Producción por procesos',
  LIVESTOCK: 'Ganadería',
  AGRICULTURE: 'Agrícola',
  SERVICES: 'Taller de servicio',
}

export const lineOfBusinessOrder: LineOfBusiness[] = ['RETAIL', 'RESTAURANT', 'GYM', 'PAWNSHOP', 'PROCESSES', 'LIVESTOCK', 'AGRICULTURE', 'SERVICES']

export const moduleLabels: Record<ModuleCode, string> = {
  restaurant: 'Restaurante',
  gym: 'Gimnasio',
  pawnshop: 'Casa de empeño',
  processes: 'Procesos',
  livestock: 'Ganadería',
  agriculture: 'Agrícola',
  accounting: 'Contabilidad',
  crm: 'CRM',
  services: 'Órdenes de servicio',
  payroll: 'Nómina',
  website: 'Sitio web',
  healthcare: 'Clínica',
  marketing: 'Marketing',
  fleet: 'Flotilla',
  parking: 'Estacionamiento',
}

/** Every sold module, in the order the catalog lists them. */
export const moduleCodes = Object.keys(moduleLabels) as ModuleCode[]

/** The catalog product that sells every module at once, the ones added later included; it is not a module itself. */
export const allModulesProductCode = 'MODULE_ALL'
export const allModulesLabel = 'Todos los módulos'

export function isAllModulesProduct(productCode: string) {
  return productCode === allModulesProductCode
}

/** Whether a catalog product sells modules: one of them, or all of them. */
export function sellsModules(productCode: string) {
  return isAllModulesProduct(productCode) || Boolean(moduleOfProduct(productCode))
}

/** The catalog product that sells a module, MODULE_<NAME>. */
export function moduleProductCode(module: ModuleCode) {
  return `MODULE_${module.toUpperCase()}`
}

/** The module a catalog product sells, or undefined for a product that is not a module. */
export function moduleOfProduct(productCode: string): ModuleCode | undefined {
  if (!productCode.startsWith('MODULE_')) return undefined
  const code = productCode.slice('MODULE_'.length).toLowerCase()
  return code in moduleLabels ? code as ModuleCode : undefined
}

/** What the line-of-business field is for, under it. */
export const lineOfBusinessHint = 'Nos dice a qué se dedica tu negocio. Los módulos se contratan aparte, uno por uno o todos juntos.'
